'use client';

import WorkflowBuilder from '@features/workflows/WorkflowBuilder';

const Workflows = () => {
  return <WorkflowBuilder />;
};

export default Workflows;
